define('job-carousel-tracking',['pulse'], function(Pulse) {
    'use strict';

    var JobbCarouselTracking = function() {
        var TRACKER_ID = 'elementTracker';

        var originType = Pulse.getPageType();
        var url = Pulse.getPageUrl();

        const id = 'e24-job-carousel';
        var options = {
            type: 'View',
            object: Pulse.getObjectBase('UIElement', {
                id: id,
                override: {
                    '@id': 'sdrn:e24:frontpage:front:element:' + id,
                    elementType: id,
                }
            }),
            origin: Pulse.getObjectBase(originType, {
                forceFields: true,
                override: {
                    url: url,
                },
            }),
        };

        function track(tracker) {
            tracker.track('trackerEvent', options);
        };

        Pulse.ready(track, TRACKER_ID);
    };

    return JobbCarouselTracking;
});

